import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useEffect} from 'react';

import * as colors from 'lib/Colors';
import {GRAY_LIGHT, NEAR_BLACK} from 'ui-library/Colors';

interface Props {
  color: string;
  className?: string;
  onSelectColor: (value: string) => void;
}

function ColorPicker({color, onSelectColor, className}: Props): JSX.Element {
  useEffect(() => {
    if (!colors.pastelColors.includes(color)) {
      onSelectColor(colors.pastelColors[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ul className={classNames(className, css(styles.colorChooser))}>
      {colors.pastelColors.map((colorOption) => (
        <li
          key={colorOption}
          className={classNames(css(styles.colorSwatch), {[css(styles.activeSwatch)]: colorOption === color})}
          style={{backgroundColor: colorOption}}
          onClick={() => {
            onSelectColor(colorOption);
          }}
        />
      ))}
    </ul>
  );
}

export default ColorPicker;

const styles = StyleSheet.create({
  colorChooser: {
    listStyle: 'none',
    padding: 0,
  },
  colorSwatch: {
    display: 'inline-block',
    width: '20px',
    height: '20px',
    marginRight: '5px',
    cursor: 'pointer',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: GRAY_LIGHT,
  },
  activeSwatch: {
    borderColor: NEAR_BLACK,
  },
});
